/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Transcription_Failed_MessageInputs */

const en_automatic_transcription_failed_message = /** @type {(inputs: Automatic_Transcription_Failed_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic transcription failed. File must be accessible via Local Storage, Proxy RT, or Cloud URL. Vimeo and YouTube links are not supported.`)
};

const fr_automatic_transcription_failed_message = /** @type {(inputs: Automatic_Transcription_Failed_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la transcription automatique. Le fichier doit être accessible via Stockage local, Proxy RT ou URL cloud. Les liens Vimeo et YouTube ne sont pas pris en charge.`)
};

const de_automatic_transcription_failed_message = /** @type {(inputs: Automatic_Transcription_Failed_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die automatische Transkription ist fehlgeschlagen. Die Datei muss über den lokalen Speicher, Proxy RT oder eine Cloud-URL zugänglich sein. Vimeo- und YouTube-Links werden nicht unterstützt.`)
};

const it_automatic_transcription_failed_message = /** @type {(inputs: Automatic_Transcription_Failed_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trascrizione automatica non riuscita. Il file deve essere accessibile tramite archiviazione locale, proxy RT o URL cloud. I link a Vimeo e YouTube non sono supportati.`)
};

const ru_automatic_transcription_failed_message = /** @type {(inputs: Automatic_Transcription_Failed_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическая транскрипция не удалась. Файл должен быть доступен через локальное хранилище, прокси-сервер или облачный URL. Ссылки на Vimeo и YouTube не поддерживаются.`)
};

const es_automatic_transcription_failed_message = /** @type {(inputs: Automatic_Transcription_Failed_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error en la transcripción automática. Se debe poder acceder al archivo mediante almacenamiento local, proxy RT o URL de la nube. No se admiten enlaces de Vimeo ni YouTube.`)
};

const zh_cn2_automatic_transcription_failed_message = /** @type {(inputs: Automatic_Transcription_Failed_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动转录失败。文件必须可通过本地存储、代理 RT 或云端 URL 访问。不支持 Vimeo 和 YouTube 链接。`)
};

const ja_automatic_transcription_failed_message = /** @type {(inputs: Automatic_Transcription_Failed_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動文字起こしに失敗しました。ファイルはローカルストレージ、プロキシRT、またはクラウドURL経由でアクセスできる必要があります。VimeoおよびYouTubeのリンクはサポートされていません。`)
};

const hi_automatic_transcription_failed_message = /** @type {(inputs: Automatic_Transcription_Failed_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित प्रतिलेखन विफल रहा। फ़ाइल लोकल स्टोरेज, प्रॉक्सी आरटी या क्लाउड यूआरएल के माध्यम से सुलभ होनी चाहिए। विमियो और यूट्यूब लिंक समर्थित नहीं हैं।`)
};

const pt_pt2_automatic_transcription_failed_message = /** @type {(inputs: Automatic_Transcription_Failed_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A transcrição automática falhou. O arquivo deve estar acessível via armazenamento local, proxy RT ou URL na nuvem. Links do Vimeo e do YouTube não são suportados.`)
};

/**
* | output |
* | --- |
* | "Automatic transcription failed. File must be accessible via Local Storage, Proxy RT, or Cloud URL. Vimeo and YouTube links are not supported." |
*
* @param {Automatic_Transcription_Failed_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_transcription_failed_message = /** @type {((inputs?: Automatic_Transcription_Failed_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Transcription_Failed_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_transcription_failed_message(inputs)
	if (locale === "de") return de_automatic_transcription_failed_message(inputs)
	if (locale === "it") return it_automatic_transcription_failed_message(inputs)
	if (locale === "ru") return ru_automatic_transcription_failed_message(inputs)
	if (locale === "es") return es_automatic_transcription_failed_message(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_transcription_failed_message(inputs)
	if (locale === "ja") return ja_automatic_transcription_failed_message(inputs)
	if (locale === "hi") return hi_automatic_transcription_failed_message(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_transcription_failed_message(inputs)
	return en_automatic_transcription_failed_message(inputs)
});